export default __webpack_public_path__ + "static/media/Staminnewlogo.975e5f13.png";